import { render, staticRenderFns } from "./venueOrderList.vue?vue&type=template&id=29c622f4&scoped=true&"
import script from "./venueOrderList.vue?vue&type=script&lang=js&"
export * from "./venueOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c622f4",
  null
  
)

export default component.exports